export class KioskSettings {
	primaryColor: string;
	isDisablePaperReceipt: boolean;
	thankYouPageText: string;
	landingPageImage: string;
	callNameLabel: string;
	enableCreditSwipe : boolean;
	enableManualCredit : boolean;
	hideInfoStep:boolean;
	removeOnScreenKeyboard : boolean;
	allowCashPaymentAtCounter : boolean;
	inActivityTimerInSec: number;
	timerAfterTransactionInSec: number;
	imagePath: string;
	showEmail: boolean;
	locationId: number;
	waiverRequired : boolean;
	waiverId:number;
	isEnableKiosk:boolean;
	kioskEnabled :boolean;
	enableTicketPrint: boolean;
	disableScanOption : boolean;
	disableProductPurchase : boolean;
	recaptcha_Keyv2: any;
	recaptcha_Key: any;
	gatewayProcessor: any;
	tenantName: any;
	enableStripeTerminalReader: boolean;
	useStripeSimulatedReader: boolean;
	stripeTerminalUrl: string;
	defaultStripeReaderId: string;
	get landingPathImagePath(): string {
		return this.landingPageImage;
	}
}
